import { TableColumnMeta } from "ds/components/Table/types";
import { IntentProjectResourcesSuggestions } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

export const INTENT_PROJECT_HISTORY_TABLE_STORAGE_KEY = "intent-project-history-table";
export const INTENT_PROJECT_HISTORY_LIMIT_STORAGE_KEY = "intent-project-history-limit";
export const INTENT_PROJECT_HISTORY_LIMIT = 50;
export const INTENT_PROJECT_HISTORY_TABLE_FILTERS_STORAGE_KEY =
  "intent-project-history-table-filters";

export const INTENT_PROJECT_HISTORY_PAGINATION_OPTIONS = [10, 25, 50];

export enum INTENT_PROJECT_HISTORY_COLUMN_ID {
  OPERATION = "OPERATION",
  RESOURCE_TYPE = "RESOURCE_TYPE",
  RESOURCE_ID = "RESOURCE_ID",
  PROVIDER = "PROVIDER",
  STATE = "STATE",
  STATE_REASON = "STATE_REASON",
  SESSION = "SESSION",
  CREATED_AT = "CREATED_AT",
  POLICY_RESULT = "POLICY_RESULT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

export const INTENT_PROJECT_HISTORY_COLUMN_CONFIG: Record<
  INTENT_PROJECT_HISTORY_COLUMN_ID,
  TableColumnMeta
> = {
  [INTENT_PROJECT_HISTORY_COLUMN_ID.OPERATION]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.OPERATION,
    title: "Operation",
    minWidth: 160,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_TYPE]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_TYPE,
    title: "Resource Type",
    minWidth: 190,
    defaultWidth: 190,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_ID]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_ID,
    title: "Resource ID",
    minWidth: 190,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.PROVIDER]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.PROVIDER,
    title: "Provider",
    minWidth: 160,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.STATE]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.STATE,
    title: "Status",
    minWidth: 200,
    defaultWidth: 260,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.STATE_REASON]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.STATE_REASON,
    title: "Failure Reason",
    minWidth: 200,
    defaultWidth: 260,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.SESSION]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.SESSION,
    title: "User",
    minWidth: 180,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.CREATED_AT]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.CREATED_AT,
    title: "Timestamp",
    minWidth: 170,
    defaultWidth: 210,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.POLICY_RESULT]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.POLICY_RESULT,
    title: "Policy Result",
    minWidth: 160,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_HISTORY_COLUMN_ID.ROW_ACTIONS]: {
    id: INTENT_PROJECT_HISTORY_COLUMN_ID.ROW_ACTIONS,
    title: "Actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const INTENT_PROJECT_HISTORY_SORT_CONFIG: Record<string, string> = {
  [INTENT_PROJECT_HISTORY_COLUMN_ID.PROVIDER]: IntentProjectResourcesSuggestions.PROVIDER,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_ID]: IntentProjectResourcesSuggestions.RESOURCE_ID,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_TYPE]: IntentProjectResourcesSuggestions.RESOURCE_TYPE,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.CREATED_AT]: IntentProjectResourcesSuggestions.CREATED_AT,
};
